// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__n2Vfg","fileBtn":"File_fileBtn__2VF6-","closeBtn":"File_closeBtn__3Lzaf","fileSelected":"File_fileSelected___7U2l","disabled":"File_disabled__3TRxz"};